import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";

import { IntegrationTypes, KnownIntegration } from "@phoenix/common";
import { PhxSelect } from "../../../shared/components/phx-select/phx-select.component";

@Component({
    selector: "app-formly-field-integration-type",
    templateUrl: "./formly-field-integration-type.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, FormlyModule, ReactiveFormsModule, PhxSelect]
})
export class FormlyFieldIntegrationTypeComponent extends FieldType {
    shopListArray = signal<{ label: string; value: IntegrationTypes }[]>([]);

    constructor() {
        super();
        // Map ShopList values to label and key pairs
        const shopListMapped = Object.entries(KnownIntegration).map(([key, value]) => ({
            label: value as string, // Use the value of the enum/object as the label
            value: key as IntegrationTypes // Use the key as the value of type ShopListType
        }));
        this.shopListArray.set(shopListMapped);
    }
}
